import type { FieldMap } from 'angular2-query-builder/dist/components';
import { createAction, props } from '@ngrx/store';
import { createSetErrorAction, createSetLoadingAction } from 'app/store/completed-entity-state/completed-entity-state';

export const getOrderFieldMap = createAction('[Field Map Request] Get Order Field Map');
export const saveOrderFieldMap = createAction('[Field Map State] Save Order Field Map', props<{ orderFieldMap: FieldMap }>());
export const markOrderFieldMapLoaded = createAction('[Field Map State] Mark Order Field Map Loaded');
export const setError = createSetErrorAction('[Field Map State] Set Error');
export const setLoading = createSetLoadingAction('[Field Map State] Set Loading');
